import type {FilterObject} from 'nutshell-core/types';

import {GAP_SELECT_VALUES_DAY_TO_YEAR} from '../report-constants';
import type {DateRangeType} from '../report-types';

type ZoomToSegmentFunction = (filters: FilterObject) => void;

/**
 * This is a thunk which will return a function to handle clicks on a chart segment
 * to "zoom-in" on the segment.  This will not return a handler if the chart is
 * displaying only one day.
 * @param  {number} currentGapIndex  The zoom level of the chart, with day being in index 0
 * @param  {number} chartBucketCount The number of buckets being displayed.
 * @param  {Function} onParamPush    A function which will update the filters
 * @param  {string} dateRangeType    The type of date filter to apply
 * @return {Function}                Chart click handler
 */
export function makeHandleClickChartToZoom(
    currentGapIndex: number,
    chartBucketCount: number,
    onParamPush: (arg1: any, arg2: boolean) => any,
    dateRangeType: DateRangeType
): ZoomToSegmentFunction | null | undefined {
    // Don't allow zooming in if we're only showing one day
    if (currentGapIndex === 0 && chartBucketCount === 1) return undefined;

    const handleClickChartSegment = (filters: FilterObject) => {
        type params = {
            filter: any;
            report?: any;
            list: {
                page: number;
            };
        };
        const newParams: params = {
            filter: {[dateRangeType]: filters[dateRangeType]},
            list: {page: 1},
        };

        if (currentGapIndex > 0) {
            // @ts-expect-error
            newParams.report = {gap: GAP_SELECT_VALUES_DAY_TO_YEAR[currentGapIndex - 1].id};
        }

        onParamPush(newParams, true);
    };

    return handleClickChartSegment;
}
